function Overlay(props) {
  return <div className="overlay" onClick={props.close}></div>;
}

export default Overlay;
